export default {"href":"/corgi/pageapps/purchase/_next/public/sprite-3.48.0-de48ae84e.svg#instagram-flat","viewBox":"0 0 512.001 512.001"}